import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState, ScreenType } from "@client/types";
import { setActiveLessonId } from "../../actions";
import { localStateSelector } from "../../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  const lessonAlignmentSelector = getSettingValueSelector(TargetSelector.Entity, "lessonAlignment");

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    const { course, lessons } = localState.activeCourse!;
    return {
      ...props,
      alignment: lessonAlignmentSelector(state, props),
      hasLessons: !!lessons.length,

      isLoading:
        !!localState.activeCourse!.activeLessonId &&
        !(localState.activeCourse!.activeLessonId in localState.lessonDetail),
      isExpanded: state.viewport.screen === ScreenType.Mobile,
      name: course.name
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onItemClick: (lessonId: string) => dispatch(setActiveLessonId({ ...getEntityRef(props), lessonId }))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
